import { ReactNode } from 'react';

import { Flex, Text } from '@backstage/ui';

interface SummarySectionProps {
  title: string;
  children: ReactNode;
}

export const SummarySection = ({ title, children }: SummarySectionProps) => (
  <Flex direction="column" gap="2">
    <Text variant="body-small" color="secondary" weight="bold">
      {title}
    </Text>
    {children}
  </Flex>
);
